import React, { useState } from "react";
import { activeUser } from "../../system/types/activeUser/activeUserType";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { localStorageHelper } from "../../system/helper/localStorage";
import { dispatch } from "../../App";
import { actions } from "../../redux";
import Icon from "@mdi/react";
import { mdiLightSwitch, mdiLightSwitchOff, mdiLogout } from "@mdi/js";
import { Menu } from "./Menu";
import { LanguageSelect } from "./LanguageSelect";

import "./Header.scss";

const Header = () => {

    const [activeUserData, setActiveUserData] = useState<activeUser>();
    const [userSessionActive, setUserSessionActive] = useState<boolean>(false);
    const [darkMode, setDarkMode] = useState<boolean>(true);


    useSelector((state: RootState) => {
        if (state.activeUser.activeUserData !== activeUserData) {
            setActiveUserData(state.activeUser.activeUserData);
        }
        if (state.activeUser.activeUserIsValid !== userSessionActive) {
            setUserSessionActive(state.activeUser.activeUserIsValid);
        }
        if (state.system.themeDark !== darkMode) {
            setDarkMode(state.system.themeDark);
        }
    });


    const getSwitch = () => {
        if (!darkMode) {
            return <Icon path={mdiLightSwitchOff} size={1} />
        }

        return <Icon path={mdiLightSwitch} size={1} />
    };

    const toggleSwitch = () => {
        dispatch(actions.system.toggleDarkTheme());
    }

    const logout = () => {
        const storage = new localStorageHelper();
        dispatch(actions.activeUser.clearData());
        storage.deleteItem('activeUserSession');
        storage.deleteItem('activeUserEmail');
    };

    return (
        <div className="header">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-auto">
                        <img className="badCode" src="/bad-code-head.png" alt="logo" />
                    </div>
                    <div className="col"></div>
                    <div className="col-auto">
                        {userSessionActive ? (
                            <div className="row  align-items-center">
                                <div className="col-auto">
                                    <Menu></Menu>
                                </div>
                                <div className="col-auto">{activeUserData?.name}</div>
                                <div className="col-auto">
                                    <span className="logout" onClick={logout}><Icon path={mdiLogout} size={1} /></span>
                                </div>
                            </div>
                        ) : null}
                    </div>
                    <div className="col-auto"><span className="switch" onClick={toggleSwitch}>{getSwitch()}</span></div>
                    <div className="col-auto"><LanguageSelect></LanguageSelect></div>
                </div>
            </div>
        </div>
    );

};

export { Header };
